import axios from 'axios';
import url from '@/constants/url';

export const generateNewToken = async (rt) => {
  return await axios
    .post(`${url.admin_api}u/token/refresh`, {
      refresh_token: rt,
    })
    .then((r) => {
      return {
        token: r.data.token,
        refreshToken: r.data.refresh_token,
      };
    })
    .catch((e) => {
      console.log('Invalid Auth data');
      throw e;
    });
};
